import { RenderAppropriate } from '../../deprecated-enkel/internals/RenderAppropriate';
import { ButtonStyle } from '../styles/form/button.styles';
import React, { ReactNode } from 'react';

interface ButtonProps {
    component?: React.ElementType;
    children?: ReactNode;
    [key: string]: any;
}

const Button: React.FC<ButtonProps> & { Style?: any } = ({ component: Component, children, ...rest }) =>
    RenderAppropriate(ButtonStyle, rest, children, Component);

Button.Style = ButtonStyle;

export { Button };
